import React from "react";
import "./Styles/footer.css"
import logoAb from "../Images/Logos/ablogo.svg";
import TextField from '@mui/material/TextField';
import Frame from "../Images/Icones/Frame.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

export default function Footer() {
    const [loading, setLoading] = React.useState(false)
    const [email, setEmail] = React.useState('')

    const sendEmail = () => {
        setLoading(true)
console.log("ouwo");
        axios.post(process.env.REACT_APP_API_BASE_URL + '/services/email/send-newsletter',
            JSON.stringify({email: email}), {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN,
            }
        }).then(a => {
            setLoading(false)

            setEmail('')

            toast.success('Votre abonnement a bien été pris en compte.')
        }).catch(error => {
            setLoading(false)
            toast.error('Une erreur est survenue');
        })
    }

    return (
        <>
            <ToastContainer/>
            <div className="topFooter">
                <div className="footer-container">
                    <img src={logoAb} alt="logo" />
                    <p className="navigation">Navigation <br /> <br /> <br />
                        <a href="#" className="Navigation-boutons">
                            Accueil
                        </a>
                        <a href="/boutique" className="Navigation-boutons">
                            Boutique
                        </a>
                    </p>

                    <p className="information">Informations <br /> <br /> <br />
                        <a href="/a-propos" className="Navigation-boutons">
                            Qui sommes nous
                        </a>
                        <a href="/cgv"  className="Navigation-boutons">
                            Conditions Générales de Vente
                        </a>
                        <a href="/confidentialite" className="Navigation-boutons">
                            Politique de confidentialité
                        </a>
                    </p>

                    <div className="newsletter">Newsletter <br /> <br />
                        <p className="Navigation-boutons">Ajoutez votre adresse mail pour souscrire à <br />
                            notre newsletter et recevoir les différentes <br /> offres promotionnelles</p>
                            <form onSubmit={(e)=>{e.preventDefault(); sendEmail()}}>
                        <div id="newsletter-form">
                                <TextField value={email} onChange={(e)=>{setEmail(e.target.value)}} disabled={loading} label="your@email.com" variant="standard" required type="email" />
                                <button type="submit" disabled={loading}>Souscrire</button>
                        </div>
                        
                        </form>
                    </div>

                </div>
                <br /><br /> <br />
                <div className="copyright">
                    <p>&copy; 2023 KabaaShop, Tout droit réservé.</p>
                </div>
            </div>
        </>

    )
}